module.exports = __webpack_public_path__ + "img/porto-3.e18a0b80.png";